/**
 * Little Things Co. - Shopify OS 2.0 Theme JS Engine
 */
document.addEventListener('DOMContentLoaded', () => {
  console.log('Little Things Co. Shopify OS 2.0 Theme Initialized.');

  // Cart Drawer Listeners
  const cartBtn = document.getElementById('header-cart-btn');
  const cartDrawer = document.getElementById('cart-drawer');
  const closeCartBtn = document.getElementById('close-cart-btn');
  const cartOverlay = document.getElementById('cart-overlay');

  if (cartBtn && cartDrawer) {
    cartBtn.addEventListener('click', () => cartDrawer.classList.remove('hidden'));
  }
  if (closeCartBtn && cartDrawer) {
    closeCartBtn.addEventListener('click', () => cartDrawer.classList.add('hidden'));
  }
  if (cartOverlay && cartDrawer) {
    cartOverlay.addEventListener('click', () => cartDrawer.classList.add('hidden'));
  }

  // Wishlist Drawer Listeners
  const wishlistBtn = document.getElementById('header-wishlist-btn');
  const wishlistDrawer = document.getElementById('wishlist-drawer');
  const closeWishlistBtn = document.getElementById('close-wishlist-btn');
  const wishlistOverlay = document.getElementById('wishlist-overlay');

  if (wishlistBtn && wishlistDrawer) {
    wishlistBtn.addEventListener('click', () => wishlistDrawer.classList.remove('hidden'));
  }
  if (closeWishlistBtn && wishlistDrawer) {
    closeWishlistBtn.addEventListener('click', () => wishlistDrawer.classList.add('hidden'));
  }
  if (wishlistOverlay && wishlistDrawer) {
    wishlistOverlay.addEventListener('click', () => wishlistDrawer.classList.add('hidden'));
  }

  // Search Modal Listeners
  const searchBtn = document.getElementById('header-search-btn');
  const searchModal = document.getElementById('search-modal');
  const closeSearchBtn = document.getElementById('close-search-btn');
  const searchOverlay = document.getElementById('search-overlay');

  if (searchBtn && searchModal) {
    searchBtn.addEventListener('click', () => searchModal.classList.remove('hidden'));
  }
  if (closeSearchBtn && searchModal) {
    closeSearchBtn.addEventListener('click', () => searchModal.classList.add('hidden'));
  }
  if (searchOverlay && searchModal) {
    searchOverlay.addEventListener('click', () => searchModal.classList.add('hidden'));
  }
});
